import { SideNavType, HATVNAVType } from "../types/types";

export enum QTypes {
  Q1 = "Q1",
  Q2 = "Q2",
}

export const LANGUAGES = [
  { label: "language_switcher.en", code: "en" },
  { label: "language_switcher.th", code: "th" },
  { label: "language_switcher.ja", code: "ja" },
  { label: "language_switcher.ko", code: "ko" },
  { label: "language_switcher.pt", code: "pt" },
  { label: "language_switcher.ru", code: "ru" },
  { label: "language_switcher.es", code: "es" },
  { label: "language_switcher.cn", code: "cn" },
  { label: "language_switcher.tw", code: "tw" },
  { label: "language_switcher.vi", code: "vi" },
];

export const SUPPORTED_LANG = ['en', 'th', 'ja', 'ko', 'pt', 'ru', 'es', 'cn', 'tw', 'vi']

export const SIDE_NAV_LINKS: SideNavType[] = [
  {
    mainTabID: "businessperformance",
    mainTabName: "ABO Growth Companion",
    innerTabs: [
      // {
      //   tabId: "business_performance",
      //   tabName: "Business Performance",
      //   isDisabled: false,
      // },
      // {
      //   tabId: "key_kpis",
      //   tabName: "Key KPIs",
      //   isDisabled: true,
      // },
      {
        tabId: "health_and_wellbeing",
        tabName: "Health & Wellbeing",
        isDisabled: true,
      },
      {
        tabId: "pipeline",
        tabName: "pipeline",
        isDisabled: false,
      },
      {
        tabId: "qualifications",
        tabName: "qualifications",
        isDisabled: false,
      },
      {
        tabId: "structure",
        tabName: "structure",
        isDisabled: false,
      },
      {
        tabId: "income",
        tabName: "income",
        isDisabled: false,
      },
      // {
      //   tabId: "probability_modeling",
      //   tabName: "Probability Modeling",
      //   isDisabled: false,
      // },
      // {
      //   tabId: "compensation",
      //   tabName: "Compensation",
      //   isDisabled: false,
      // },
    ],
  },
  {
    mainTabID: "growthplan",
    mainTabName: "Growth Plan",
    innerTabs: [
      {
        tabId: "goals",
        tabName: "Goals",
        isDisabled: false,
      },
      // {
      //   tabId: "notes",
      //   tabName: "Progress Notes",
      //   isDisabled: false,
      // },
    ],
  },
  {
    mainTabID: "notesdocument",
    mainTabName: "Notes & Documents",
    innerTabs: [
      {
        tabId: "notes",
        tabName: "Progress Notes",
        isDisabled: false,
      },
      {
        tabId: "documents",
        tabName: "Documents",
        isDisabled: false,
      },
    ],
  },
  {
    mainTabID: "leaderInformation",
    mainTabName: "Personal Information",
    innerTabs: [
      {
        tabId: "contact_information",
        tabName: "Contact Information",
        isDisabled: false,
      },
      {
        tabId: "IBO_background",
        tabName: "IBO Background",
        isDisabled: false,
      },
      {
        tabId: "succession_plan",
        tabName: "Succession Plan",
        isDisabled: false,
      },
    ],
  },
  {
    mainTabID: "hatvqmonth",
    mainTabName: "HATV Q Months",
    innerTabs: [],
  },
  {
    mainTabID: "hatvawards",
    mainTabName: "HATV Awards",
    innerTabs: [],
  },
];

export const AP_SIDE_NAV_LINKS: SideNavType[] = [
  {
    mainTabID: "ap_information",
    mainTabName: "AP Information",
    innerTabs: [
      {
        tabId: "background",
        tabName: "Background",
      },
      {
        tabId: "notes",
        tabName: "Notes",
      },
      {
        tabId: "documents",
        tabName: "Documents",
      },
    ],
  },
];

export const HATV_NAV_LINKS: HATVNAVType[] = [
  {
    mainTabID: "hatv_q_month_approval",
    mainTabName: "HATV Q Month Approval",
  },
  {
    mainTabID: "hatv_award_approval",
    mainTabName: "HATV Award Approval",
  },
];

export const ALLOWED_FILE_TYPES = [
  "application/pdf",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  "application/msword",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  "application/vnd.ms-excel",
  "application/vnd.openxmlformats-officedocument.presentationml.presentation",
  "application/vnd.ms-powerpoint",
];

export const QUERY_STATUS = {
  ACTIVE: 1,
  EXPIRED: 2,
  SUSPENDED: 2,
  REVOKED: 3,
  LOGOUT: 9,
  INACTIVE: 9,
};

export const localeDateMappings: {
  [key: string]: {
    dateFormat: string;
    longDateFormat: string;
    dateTimeFormat: string;
  };
} = {
  ANA: {
    dateFormat: "MM/dd/yyyy",
    longDateFormat: "MMM dd, yyyy",
    dateTimeFormat: "MM/dd/yy h:mma",
  },
  THA: {
    dateFormat: "dd/MM/yyyy",
    longDateFormat: "dd MMM yyyy",
    dateTimeFormat: "dd/MM/yy h:mma",
  },
  // Add more mappings as needed
};

export const countryCodeMappings: { [key: string]: string } = {
  "010": "ANA",
  "200": "THA",
  "020": "CAN",
  "580": "DO",

  // Add more mappings as needed
};

export const currencyLocaleMappings: { [key: string]: string } = {
  THB: "th-TH",
  USD: "en-US",
  DOP: "es-DO",
  INR: "en-IN",
  JPY: "ja-JP",
  KRW: "ko-KR",
  CNY: "zh-CN",
  EUR: "de-DE",
  RUB: "ru-RU",
  VND: "vi-VN",
  UAH: "uk-UA",
  // Add more mappings as needed
};

export const countryLocaleMappings: { [key: string]: string } = {
  "200": "th-TH",
  "010": "en-US",
  // Add more mappings as needed
};

export const countryMappings: { [key: string]: string } = {
  "200": "th",
  "010": "us",
  // Add more mappings as needed
};

export const currencyMappings: { [key: string]: string } = {
  "200": "usd",
  "010": "thb",
  // Add more mappings as needed
};

export const footerLinks: {
  [key: string]: { privacyPolicy: string; termsConditions: string };
} = {
  "010": {
    privacyPolicy: "https://www.amwayglobal.com/privacy-notice/united-states/",
    termsConditions:
      "https://www.amway.com/en_US/support-center/policies-and-terms#TermsofUseSubcategoryComponent",
  },
  "200": {
    privacyPolicy: "https://www.amwayglobal.com/privacy-notice/thailand/",
    termsConditions: "https://www.amway.co.th/terms-of-use",
  },
  "020": {
    privacyPolicy: "https://www.amwayglobal.com/privacy-notice/canada/",
    termsConditions:
      "https://www.amway.ca/en_CA/support-center/policies-and-terms#TermsofUseSubcategoryComponent",
  },
  "580": {
    privacyPolicy:
      "https://www.amwayglobal.com/privacy-notice/dominican-republic/",
    termsConditions:
      "https://www.amway.ca/en_CA/support-center/policies-and-terms#TermsofUseSubcategoryComponent",
  },
  // Add more mappings as needed
};

export const awardGroupCodeMapping: { [key: string]: string } = {
  all_accounts: "000-999",
  diamond_above_default: "380-999",
  founders_platinum_emerald: "342-375",
  sp_gp_platinum: "310-330",
};

export const awardGroupCodeMappingHATV: { [key: string]: number } = {
  my_account: 2,
  all_case_evaluator: 1,
  red_flag: 1,
  yellow_flag: 2,
  verified: 2,
  not_verified: 1,
};

export const aboColumnMapping: {
  [key: string]: { columnName: string; valueMapping: string | string[] };
} = {
  "tracking-award": {
    columnName: "Tracking_Award",
    valueMapping: "trackingAward.awardCode",
  },
  "pggi-pq": {
    columnName: "PGI_PQs",
    valueMapping: "groupGrowthIncentive.kpiValue",
  },
  fgiTracking: {
    columnName: "FGI_PQs",
    valueMapping: "fgiTracking.fgiTracking.multiplier",
  },
  "monthly-revenue": {
    columnName: "Monthly_Revenue",
    valueMapping: "monthlyRevenue.kpiValue",
  },
  "monthly-contributor": {
    columnName: "Monthly_Contributors",
    valueMapping: "monthlyContributor.kpiValue",
  },
  "annual-revenue": {
    columnName: "Annual_Revenue YTD",
    valueMapping: "annualRevenue.kpiValue",
  },
  "annual-contributor": {
    columnName: "Annual_Contributors",
    valueMapping: "annualContributor.kpiValue",
  },
  "gpv-last": {
    columnName: "Last_Month_GPV",
    valueMapping: "lastMonthGroupPV.kpiValue",
  },
  "gpv-current": {
    columnName: "This_Month_GPV",
    valueMapping: "currentMonthGroupPV.kpiValue",
  },
  "rpv-last": {
    columnName: "Last_Month_RPV",
    valueMapping: "lastMonthRubyPV.kpiValue",
  },
  "rpv-current": {
    columnName: "This_Month_RPV",
    valueMapping: "currentMonthRubyPV.kpiValue",
  },
  ppv: {
    columnName: "This_Month_PPV",
    valueMapping: "currentMonthPersonalPV.kpiValue",
  },
  // "ql":
  // {
  //   columnName: "Q_Legs",
  //   valueMapping: "qualifiedLeg.kpiValue",
  // },
  // "qm":
  // {
  //   columnName: "Q_Months",
  //   valueMapping: "qualifiedMonth.kpiValue",
  // },
  "ttci-ttca": {
    columnName: "ttci_ttca",
    valueMapping: "trackingTwoTimeAward.trackingTwoTimeAward.awardCode",
  },
  totalSPQualifiedMonthsLos: {
    columnName: "Total_Qs",
    valueMapping: "totalSPQualifiedMonthsLos.kpiValue",
  },
  productivityPerContributor: {
    columnName: "productivity_contributor",
    valueMapping: "productivityPerContributor.kpiValue",
  },
};

type FilterDataType = {
  id: string;
  name: string;
};

export const NOTES_SORT_LIST: FilterDataType[] = [
  {
    id: "newest_first",
    name: "Newest First",
  },
  {
    id: "oldest_first",
    name: "Oldest First",
  },
];

export const noteTaglist: string[] = [
  "EAP",
  "Business Plan",
  "Event Support",
  "LGS Action",
  "BSM",
];

export const PAGE_SIZE = 20;

type FilterTileType = {
  kpiCode: string;
  title: string;
  label: string;
  category: string;
};
export const KPI_KEYS: { [key: string]: string } = {
  groupSize: "groupSize",
  contributors: "contributors",
  groupLeaderPPV: "groupLeaderPPV",
  volumeFlunctuation: "volumeFlunctuation",
  groupEomVolume: "groupEomVolume",
  tenure: "tenure",
};

export const HATV_FLAGGED_KPIS = {
  summary: "summary",
  groupSize: "groupSize",
  contributorCount: "contributorCount",
  highestPpvInGroup: "highestPpvInGroup",
  volumeFluctuation: "volumeFluctuation",
  eomGpv: "eomGpv",
  tenure: "tenure",
  bcrCase: "bcrCase",
};

export const ReportName: { [key: string]: string } = {
  gar_tracking_report: "GAR Tracking / QC Analysis",
  als_tracking_report: "ALS Points and Qualifiers Tracking",
};

export const HATV_AWARD_ROUTING_STATUS = {
  NOT_VERIFIED: 0,
  READY: 1,
  ROUTED: 2,
  APPROVE: 3,
  DENY: 9,
} as const;

export const HATV_Q_MONTH_APPROVAL_STATUS = {
  NOT_VERIFIED: 0,
  APPROVE: 1,
  ON_HOLD: 2,
  INACTIVE: 6,
  DENY: 9,
} as const;

export const q_month_approval_status  = {  
  NOT_VERIFIED: 0,
  APPROVE: 1,
  ON_HOLD: 2,
  INACTIVE: 6,
  DENY: 9,
} as const;

export const HATV_QUALIFICATION_ACTION = {
  APPROVE: 1,
  PAUSE: 2,
  DENY: 9,
};

export const HATV_APPROVAL_ACTION = {
  APPROVE: 3,
  DENY: 9,
};
export const AWARD_APPROVAL_STATUS_APPROVER = [
  { label: "NOT_VERIFIED", code: 0 },
  { label: "READY_FOR_ROUTING", code: 1 },
  { label: "ROUTED", code: 2 },
  { label: "APPROVE", code: 3 },
  { label: "DENY", code: 9 },
];

export const ABOAssignKeyMap = {
  trackingAward: "aboAssignmentTrackingAwardCodes",
  currentAward: "aboAssignmentCurrentAwardCodes",
  primaryAM: "aboAssignmentAmNativeIds",
  caseEvaluator: "aboAssignmentCeNativeIds",
  uplineDiamond: "aboAssignmentUplineDiamondAbos",
  uplineEmerald: "aboAssignmentUplineEmeraldAbos",
  amEmerald: "aboAssignmentUplineEmeraldAmNativeIds",
  language: "aboAssignmentLanguageCodes",
  marketName: "aboAssignmentMarketCodes",
  state: "aboAssignmentStateCodes",
  loa: "aboAssignmentLoa",
};

export const ACTIONS = {
  ADD_ACTIONS: "Add Action",
  ADD_EDIT_METRICS: "Add/Edit Metrics",
  EDIT: "Edit",
  DELETE: "Delete",
  DELETE_METRICS: "DELETE_METRICS",
};
export const GOAL_STATUS = [
  { label: "On Track", code: 1 },
  { label: "At Risk", code: 2 },
  { label: "Completed", code: 3 },
  { label: "Deferred", code: 4 },
  { label: "Cancelled", code: 5 },
  { label: "Inactive", code: 9 },
];

export const GOAL_ACTION_STATUS = [
  { label: "Not Started", code: 0 },
  { label: "On Track", code: 1 },
  { label: "At Risk", code: 2 },
  { label: "Completed", code: 3 },
  { label: "Deferred", code: 4 },
  { label: "Inactive", code: 9 },
];

export const TIME_FRAME_TYPE = [
  { code: 1, value: "Current PY" },
  { code: 2, value: "Future PY" },
  { code: 3, value: "1-3 Months" },
  { code: 4, value: "3-11 Months" },
];

export const INCOME_TYPES = [
  { code: 1, value: "Monthly" },
  { code: 2, value: "Annual" },
];
export const PERFORMANCE_AREA: Metric[] = [
  { code: "goal-performancemetriccategory-pipeline", value: "Pipeline" },
  { code: "goal-performancemetriccategory-structure", value: "Structure" },
  { code: "goal-performancemetriccategory-portfolioperformance", value: "Portfolio Performance" },
  { code: "goal-performancemetriccategory-qualificationincome", value: "Qualification & Income" },
];
export const PERFORMANCE_METRICS:PerformanceMetrics = {
  Pipeline: [
    { code: "aboApplications", value: "Total ABO Apps" },
    { code: "activationRate90", value: "90 Day Activation Rate" },
    { code: "productivityPerContributor", value: "Contributor Productivity" },
    { code: "averageBronze", value: "Monthly Average Bronze" },
    { code: "pipelineFaaPoints", value: "FAA Points" },
  ],
  Structure: [
    { code: "qMiz", value: "Q Miz" },
    { code: "renewalRate", value: "Renewal Rate" },
    { code: "structureFaaPoints", value: "FAA Points" },
    { code: "rubyPv", value: "Ruby PV" },
    { code: "totalSPQualifiedMonthsLos", value: "Total Qs" },
    { code: "foundersPlatinumLegCount", value: "FP Legs" },
    { code: "garQC", value: "QCs" },
  ],
  "Portfolio Performance": [
    { code: "totalRevenue", value: "Revenue" },
    { code: "totalRevenueBusiness", value: "Revenue by Business Line" },
    { code: "totalRevenueCategoryMix", value: "Revenue by Category Mix" },
    { code: "totalRevenueSubCategory", value: "Revenue by Sub Category" },
    { code: "topTenProduct", value: "Top Ten Products" },
  ],
  "Qualification & Income": [
    { code: "personalPv", value: "Personal PV" },
    { code: "groupPv", value: "Group PV" },
    { code: "totalIncome", value: "Total Income" },
    { code: "corePlanIncome", value: "Core Plan Bonus" },
    { code: "corePlusIncome", value: "Core Plus Bonus" },
    { code: "retailMargin", value: "Retail Margin" },
  ],
};
export const typeOptions = [
  { code: 1, value: "Consultation" },
  { code: 2, value: "Event" },
  { code: 3, value: "Touchpoint" },
  { code: 9, value: "Other" },
];

export const channelOptions = [
  { code: 1, value: "InPerson" },
  { code: 2, value: "VoiceOrVideo" },
  { code: 3, value: "MessageEmailorText" },
  { code: 9, value: "Other" },
];

export const timeOutPeriod = 3000;

export const INDIVIDUAL_RECOGNITION = [
  { code: 1, value: "On Stage" },
  { code: 2, value: "Private" },
  { code: 3, value: "Print or Post" },
  { code: 9, value: "Other" },
];

